export interface Article {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  date: string;
  views: number;
  commentCount: number;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 1,
    title: '某千万粉网红疑似塌房，前男友曝光三年聊天记录',
    slug: 'qianwanfen-wanghong-tafang',
    excerpt: '近日，一位拥有超过三千万粉丝的头部网红被前男友爆出大量私密聊天截图，内容涉及人设造假、数据刷量等内幕，引发全网热议。',
    content: '<p>近日，一位拥有超过三千万粉丝的头部网红被前男友爆出大量私密聊天截图，内容涉及人设造假、数据刷量、私下辱骂粉丝等内幕，引发全网热议。</p><p>据爆料者称，两人交往期间，该网红多次在微信中吐槽粉丝「全是韭菜」，并在双十一前夕与品牌方商议如何通过剧本炒作提高带货转化率。聊天记录中还显示该网红曾让团队批量购买水军刷评论和点赞。</p><p>目前该网红尚未对此事做出公开回应，但其最新视频评论区已涌入大量网友质疑。</p>',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20smartphone%20screen%20displaying%20chat%20messages%20with%20blurred%20text%2C%20surrounded%20by%20dramatic%20red%20and%20dark%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%2C%20warm%20dark%20tones%20with%20crimson%20highlights%2C%20soft%20bokeh%20effect%2C%20editorial%20style&width=800&height=500&seq=article-01-hot&orientation=landscape',
    date: '2026-07-07',
    views: 1280000,
    commentCount: 35600,
    isHot: true,
    isNew: true,
    tags: ['网红', '塌房', '聊天记录', '人设造假']
  },
  {
    id: 2,
    title: '某知名女星与经纪人暧昧对话曝光，工作室紧急公关',
    slug: 'nvxing-jingjiren-aimai',
    excerpt: '一组疑似某一线女星与其经纪人的微信对话截图在某社交平台疯传，内容尺度之大令人咋舌，粉丝群体陷入分裂。',
    content: '<p>一组疑似某一线女星与其经纪人的微信对话截图在某社交平台疯传。对话内容包含大量暧昧信息，时间跨度达两年之久，内容尺度之大令人咋舌。</p><p>截图中显示，该女星曾多次在深夜向经纪人发送私密照片，并以「老公」相称。更令人震惊的是，聊天记录中还涉及对同组演员的私下评价和行业内幕爆料。</p><p>消息传出后，该女星工作室迅速发布声明称「聊天记录系伪造，将依法追究造谣者法律责任」。然而部分细节与公开信息高度吻合，使得声明说服力大打折扣。</p>',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20lying%20on%20a%20dark%20table%20showing%20WeChat%20chat%20interface%20with%20blurred%20content%2C%20moody%20atmospheric%20lighting%2C%20film%20noir%20style%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20dramatic%20composition%2C%20mysterious%20vibe&width=800&height=500&seq=article-02-hot&orientation=landscape',
    date: '2026-07-06',
    views: 956000,
    commentCount: 42300,
    isHot: true,
    isNew: true,
    tags: ['明星', '聊天记录', '暧昧', '工作室声明']
  },
  {
    id: 3,
    title: '某顶流男团成员私下聚会视频流出，行为引争议',
    slug: 'nanxing-nantuan-juhui',
    excerpt: '一段疑似某顶流男团成员在私人聚会上不当行为的视频在海外平台流出，随后被搬运至国内，引发粉丝与路人激烈争论。',
    content: '<p>一段疑似某顶流男团成员在私人聚会上不当行为的视频在海外平台流出，随后被搬运至国内各大社交平台。视频中该成员与多名女性举止亲密，状态明显异常。</p><p>视频发布后，该男团所属经纪公司火速发布公告，称「视频中并非本公司艺人，系恶意造谣」，但网友们通过对比该成员近期照片中的衣着配饰，发现了多处匹配细节。</p><p>目前该成员个人社交账号评论区已关闭，但其超话内粉丝与路人仍在激烈争论视频真实性。</p>',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Blurred%20nightclub%20scene%20with%20colorful%20neon%20lights%20and%20silhouettes%20of%20people%2C%20dark%20atmospheric%20photo%2C%20party%20vibe%2C%20motion%20blur%20effect%2C%20warm%20red%20and%20purple%20mood%20lighting%2C%20cinematic%20grainy%20texture&width=800&height=500&seq=article-03&orientation=landscape',
    date: '2026-07-06',
    views: 756000,
    commentCount: 28900,
    isHot: true,
    isNew: false,
    tags: ['男团', '聚会', '视频流出', '争议']
  },
  {
    id: 4,
    title: '某美食博主被曝食材造假，粉丝群内道歉录音遭泄露',
    slug: 'meishi-bozhu-zaojia',
    excerpt: '拥有两千万粉丝的知名美食博主被前员工曝光长期使用劣质食材替代高端食材进行拍摄，一段在粉丝群内的道歉语音随后外泄。',
    content: '<p>拥有两千万粉丝的知名美食博主被前员工曝光长期使用劣质食材替代高端食材进行拍摄。据爆料者提供的证据显示，该博主在视频中展示的「澳洲和牛」实际是普通国产牛肉，而「进口帝王蟹」则是本地菜市场购买的面包蟹。</p><p>更令人震惊的是，一段该博主在核心粉丝群内的道歉语音被群成员录屏外泄。语音中该博主承认「确实有些食材是替代品」，但辩称「味道其实差不多，只是为了节目效果」。</p><p>此事曝光后，多个品牌方宣布与其解约，该博主已删除大量往期视频并关闭评论区。</p>',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxurious%20food%20plating%20on%20a%20dark%20table%2C%20surrounded%20by%20shadows%2C%20half%20eaten%20dish%2C%20moody%20restaurant%20lighting%2C%20warm%20dark%20atmosphere%2C%20contrast%20between%20luxury%20and%20deception%2C%20editorial%20food%20photography&width=800&height=500&seq=article-04&orientation=landscape',
    date: '2026-07-05',
    views: 632000,
    commentCount: 31200,
    isHot: true,
    isNew: false,
    tags: ['美食博主', '造假', '食材', '道歉录音']
  },
  {
    id: 5,
    title: '91吃瓜独家：某选秀冠军被扒黑历史，学生时期言论引争议',
    slug: 'xuanxiu-guanjun-heilishi',
    excerpt: '近日，一位去年选秀节目冠军被网友扒出学生时期在社交平台的大量不当言论，涉及地域歧视和人身攻击。',
    content: '<p>近日，一位去年选秀节目冠军被网友扒出学生时期在社交平台的大量不当言论。这些发布于7-8年前的动态涉及地域歧视、人身攻击以及对特定群体的不尊重。</p><p>虽然该艺人目前已将这些内容全部删除，但网友早已截图保存。粉丝后援会紧急发布声明称「青少年时期的言论不能代表现在的价值观」，但网友并不买账，认为「互联网是有记忆的」。</p><p>目前该艺人正在参与的新综艺节目已将其镜头大幅删减，多个商业代言也在观望中。</p>',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20spotlight%20on%20an%20empty%20stage%20with%20a%20microphone%20stand%2C%20dark%20auditorium%2C%20dramatic%20single%20light%20beam%2C%20contrast%20between%20fame%20and%20shadow%2C%20theatrical%20moody%20atmosphere%2C%20warm%20golden%20spotlight%20on%20dark%20background&width=800&height=500&seq=article-05&orientation=landscape',
    date: '2026-07-05',
    views: 891000,
    commentCount: 45100,
    isHot: true,
    isNew: false,
    tags: ['选秀冠军', '黑历史', '言论', '争议']
  },
  {
    id: 6,
    title: '某短视频平台头部主播偷税被查，金额或超千万',
    slug: 'zhubo-toushui-beicha',
    excerpt: '税务部门通报某短视频平台头部主播涉嫌偷逃税款，目前案件正在进一步调查中，该主播账号已被平台限制。',
    content: '<p>税务部门最新通报显示，某短视频平台头部主播因涉嫌偷逃税款被立案调查。据知情人士透露，涉案金额可能超过千万元。</p><p>该主播在平台上拥有超过5000万粉丝，年带货GMV数十亿。通报发出后，其所有社交账号均被平台限制，直播功能已被暂停。其合作的品牌方纷纷下架关联商品并删除合作内容。</p><p>这是继去年多位头部主播税务风波后的又一起重磅案件，引发行业震动。</p>',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxurious%20office%20desk%20with%20stacks%20of%20money%20in%20shadow%2C%20dark%20moody%20lighting%2C%20half%20open%20ledger%20books%2C%20dramatic%20atmospheric%20scene%2C%20warm%20dark%20tones%2C%20film%20noir%20aesthetic&width=800&height=500&seq=article-06&orientation=landscape',
    date: '2026-07-04',
    views: 1040000,
    commentCount: 52300,
    isHot: true,
    isNew: false,
    tags: ['主播', '偷税', '税务', '平台限制']
  },
  {
    id: 7,
    title: '某古装剧男二被曝片场耍大牌，工作人员匿名投稿吐槽',
    slug: 'guzhuangju-shuadapai',
    excerpt: '一位自称某热播古装剧组工作人员的网友匿名投稿，详细描述了剧中男二号在拍摄期间的种种令人不满行为。',
    content: '<p>一位自称某热播古装剧组工作人员的网友匿名投稿，详细描述了剧中男二号在拍摄期间的种种令人不满行为。</p><p>据该工作人员描述，这位男演员经常迟到超过两个小时，到场后还要花大量时间自拍发社交媒体。更过分的是，在一次群演都在等待的情况下，他以「状态不好」为由拒绝拍摄，导致全组收工时间推迟到凌晨三点。</p><p>投稿中还提到，该演员对工作人员的称呼极其不尊重，多位场务人员因此提出离职。目前该剧组官方尚未对此事做出回应。</p>',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20Chinese%20historical%20drama%20film%20set%2C%20empty%20director%20chair%2C%20costumes%20hanging%2C%20dim%20lighting%2C%20lonely%20atmosphere%2C%20warm%20tones%2C%20cinematic%20composition&width=800&height=500&seq=article-07&orientation=landscape',
    date: '2026-07-04',
    views: 567000,
    commentCount: 21800,
    isHot: false,
    isNew: false,
    tags: ['古装剧', '耍大牌', '片场', '匿名爆料']
  },
  {
    id: 8,
    title: '吃瓜日报：某知名品牌代言人翻车，连夜撤下所有广告牌',
    slug: 'daiyanren-fanche',
    excerpt: '某国民级消费品牌最新代言人因卷入负面新闻，品牌方连夜撤下全国所有线下广告牌，损失或达数千万。',
    content: '<p>某国民级消费品牌最新代言人因卷入负面新闻，品牌方连夜启动危机公关，全国范围内的广告牌、灯箱和商场大屏在24小时内全部撤换。</p><p>该代言人于一个月前刚刚官宣，品牌投入了巨额营销费用，据业内人士估算，此次翻车事件给品牌造成的直接和间接损失可能超过5000万元。</p><p>品牌方在凌晨发布简短声明称「已与代言人解除合作关系」，但未详细说明原因。网友纷纷猜测与近日该代言人的私生活爆料有关。</p>',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20billboard%20being%20taken%20down%20at%20night%20in%20a%20Chinese%20city%2C%20workers%20on%20ladder%2C%20dark%20urban%20scene%2C%20dramatic%20city%20lights%2C%20warm%20neon%20glow%2C%20cinematic%20night%20photography&width=800&height=500&seq=article-08&orientation=landscape',
    date: '2026-07-03',
    views: 723000,
    commentCount: 33500,
    isHot: false,
    isNew: false,
    tags: ['代言人', '翻车', '品牌', '解约']
  },
  {
    id: 9,
    title: '独家：某网红情侣分手内幕，第三者竟是共同好友',
    slug: 'wanghong-qinglv-fenshou',
    excerpt: '一对拥有千万粉丝的网红情侣上个月官宣分手时称和平分手，但近日有知情人爆料第三者插足细节。',
    content: '<p>一对拥有千万粉丝的网红情侣上个月官宣分手时称「和平分手」，双方粉丝虽有遗憾但也送上祝福。然而近日有知情人爆料，分手真正原因是第三者插足，而这位第三者竟是两人的共同好友，同样是一位知名网红。</p><p>据爆料者提供的时间线，男方与第三者在三个月前就开始频繁互动，多次以「工作合作」为由单独见面。女方发现后曾试图挽回，但最终选择体面分手。</p><p>目前三方均未对此事做出回应，但网友发现女方最新动态中有一句「信任是易碎品」，疑似暗指此事。</p>',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20broken%20heart%20made%20of%20glass%20shards%20on%20a%20dark%20surface%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20shadow%20tones%2C%20emotional%20atmosphere%2C%20artistic%20still%20life%20photography&width=800&height=500&seq=article-09&orientation=landscape',
    date: '2026-07-03',
    views: 678000,
    commentCount: 38700,
    isHot: false,
    isNew: false,
    tags: ['网红情侣', '分手', '第三者', '内幕']
  },
  {
    id: 10,
    title: '某综艺节目选手被曝学历造假，学校官网查无此人',
    slug: 'xueli-zaojia-zongyi',
    excerpt: '一档热门综艺节目的高人气选手近日被网友质疑学历造假，其声称毕业的国外大学官网上无法查到该学生信息。',
    content: '<p>一档热门综艺节目的高人气选手近日被网友质疑学历造假。该选手在节目中多次声称自己毕业于国外某知名大学，但有心网友查询该校官网的校友数据库后，并未找到该选手的任何信息。</p><p>随后有网友发现该选手的领英页面也已悄然修改，毕业院校被替换为一所知名度较低的学校。这一举动被解读为心虚表现。</p><p>节目组对此回应称「正在核实选手背景信息，将根据核实结果做出相应处理」。该选手目前已暂停社交媒体更新。</p>',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20diploma%20certificate%20lying%20on%20a%20dark%20desk%20with%20a%20magnifying%20glass%2C%20dramatic%20lighting%2C%20investigation%20mood%2C%20warm%20dark%20tones%2C%20mysterious%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=article-10&orientation=landscape',
    date: '2026-07-02',
    views: 445000,
    commentCount: 19800,
    isHot: false,
    isNew: false,
    tags: ['综艺', '学历造假', '选手', '翻车']
  },
  {
    id: 11,
    title: '某知名演员与制片人微信记录外泄，片酬内幕浮出水面',
    slug: 'yanyuan-weixin-jilu',
    excerpt: '一份据称是某实力派演员与制片人的完整微信聊天记录被曝光，其中详细讨论了片酬拆分、阴阳合同等敏感话题。',
    content: '<p>一份据称是某实力派演员与制片人的完整微信聊天记录被曝光。记录时间横跨近一年，详细讨论了片酬拆分方案、阴阳合同操作方式以及如何规避税务审查等敏感话题。</p><p>聊天记录中，制片人多次指导该演员如何将片酬分为「演出费」「编剧费」「监制费」等多个名目，以降低个人所得税税率。此外，对话中还涉及某知名导演私下收取回扣的暗示。</p><p>目前该演员工作室已紧急发布声明称「聊天记录断章取义」，但税务部门表示将关注此事并依法展开核查。</p>',
    category: '聊天记录',
    categorySlug: 'liaotian-jilu',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20desk%20with%20a%20smartphone%20showing%20WeChat%20chat%20interface%20with%20blurred%20text%2C%20contract%20papers%20scattered%20around%2C%20moody%20office%20lighting%2C%20film%20noir%20style%2C%20warm%20golden%20desk%20lamp%2C%20mysterious%20atmosphere%2C%20corporate%20intrigue%20vibe&width=800&height=500&seq=article-11&orientation=landscape',
    date: '2026-07-07',
    views: 534000,
    commentCount: 28900,
    isHot: false,
    isNew: true,
    tags: ['微信记录', '片酬', '阴阳合同', '税务']
  },
  {
    id: 12,
    title: '最新吃瓜：某女团成员疑似恋爱，粉丝拍到甜蜜同行',
    slug: 'nvtuan-liana-yi',
    excerpt: '有粉丝在某商场偶遇某当红女团成员与一神秘男子十指紧扣逛街，照片在网络疯传，经纪公司尚未回应。',
    content: '<p>今日下午，有网友在社交媒体晒出在某高端商场偶遇某当红女团成员的照片。照片中该成员与一名身高约185cm的神秘男子十指紧扣，两人举止亲密，有说有笑地逛街购物。</p><p>该网友表示，当时还看到两人进入了一家珠宝店，停留了约20分钟后离开。此消息一出，粉丝群体立刻炸开锅，有人心碎表示「塌房了」，也有人理性呼吁「偶像也有恋爱自由」。</p><p>截至目前，该女团所属经纪公司尚未对此事做出任何回应。但据业内人士透露，公司内部正在紧急讨论公关策略。</p>',
    category: '最新吃瓜',
    categorySlug: 'zuixin-chigua',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20shopping%20mall%20interior%20with%20blurred%20silhouettes%20of%20a%20couple%20walking%20hand%20in%20hand%2C%20warm%20golden%20lighting%2C%20upscale%20retail%20atmosphere%2C%20paparazzi%20style%20photography%2C%20candid%20moment%2C%20soft%20focus%2C%20dramatic%20shadows&width=800&height=500&seq=article-12&orientation=landscape',
    date: '2026-07-07',
    views: 412000,
    commentCount: 22300,
    isHot: false,
    isNew: true,
    tags: ['女团', '恋爱', '偶遇', '粉丝']
  },
  {
    id: 13,
    title: '热门推荐：2026上半年十大网红翻车名场面盘点',
    slug: 'shangbannian-fanche-pandian',
    excerpt: '2026年已经过半，这半年来网红圈翻车事件层出不穷。我们为大家盘点了十大最具代表性的翻车名场面，看看有没有你关注的那位。',
    content: '<p>2026年已经过半，这半年来网红圈翻车事件层出不穷。从不当言论到税务问题，从人设崩塌到法律纠纷，每一个翻车事件都引发了全民热议。我们为大家盘点了十大最具代表性的翻车名场面。</p><p>排名第一的当属年初某三千万粉网红直播时的不当言论事件，直接导致其账号被永久封禁。第二是五月份爆发的MCN机构集体刷量造假丑闻，涉及数十位头部主播。第三名则是最近的偷税风波，涉案金额据称高达数千万元。</p><p>这些事件不仅让当事人付出了惨重代价，也为整个行业敲响了警钟。越来越多的网友开始呼吁加强对网红行业的监管力度。</p>',
    category: '热门推荐',
    categorySlug: 'remen-tuijian',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20theater%20stage%20with%20multiple%20spotlights%20shining%20down%2C%20dramatic%20shadows%20of%20people%20on%20the%20backdrop%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20entertainment%20industry%20aesthetic%2C%20grand%20scale%2C%20theatrical%20atmosphere&width=800&height=500&seq=article-13&orientation=landscape',
    date: '2026-07-06',
    views: 673000,
    commentCount: 41200,
    isHot: false,
    isNew: false,
    tags: ['盘点', '翻车', '网红', '2026']
  }
];

export const categories = [
  { name: '网红爆料', slug: 'wanghong-baoliao', icon: 'ri-user-smile-line', count: 42 },
  { name: '明星八卦', slug: 'mingxing-bagua', icon: 'ri-star-line', count: 56 },
  { name: '聊天记录', slug: 'liaotian-jilu', icon: 'ri-message-2-line', count: 31 },
  { name: '最新吃瓜', slug: 'zuixin-chigua', icon: 'ri-fire-line', count: 28 },
  { name: '热门推荐', slug: 'remen-tuijian', icon: 'ri-thumb-up-line', count: 19 }
];

export const reviews = [
  {
    id: 1,
    name: '吃瓜群众小王',
    avatarColor: '#e85d75',
    content: '每天必刷的网站！更新速度超快，比微博热搜还及时。上次那个网红塌房的料，我在这里看完去微博，热搜都还没上！'
  },
  {
    id: 2,
    name: '八卦小能手',
    avatarColor: '#f4a261',
    content: '吃瓜吃了这么多年，这个站的料是真的多！聊天记录截图都是高清无水印，看得太过瘾了。'
  },
  {
    id: 3,
    name: '深夜吃瓜人',
    avatarColor: '#2a9d8f',
    content: '作为一个互联网原住民，我可以负责任地说——这里的瓜，保熟！好多独家内幕我在其他地方根本找不到。'
  },
  {
    id: 4,
    name: '吃瓜不吐籽',
    avatarColor: '#e76f51',
    content: '从91那时候就开始跟了，现在的每日吃瓜内容更丰富，界面也更清爽。忠实老粉了！'
  },
  {
    id: 5,
    name: '娱乐观察员',
    avatarColor: '#6d597a',
    content: '不光有瓜，还有一些深度分析文章挺有意思的。不是纯八卦，偶尔还能看到行业思考，格局打开了。'
  },
  {
    id: 6,
    name: '追瓜少女',
    avatarColor: '#f9844a',
    content: '姐妹们冲！这里的评论区和瓜一样精彩哈哈哈哈，每天睡前必刷，一刷就是一个小时。根本停不下来！'
  }
];

export const stats = [
  { value: '500万+', label: '月活跃用户' },
  { value: '10万+', label: '累计爆料' },
  { value: '99.7%', label: '用户满意度' },
  { value: '50+', label: '独家信源' }
];